module.exports = __webpack_public_path__ + "img/gift-01-c4.1429ab66.png";